import React, { useState } from 'react';
import {
  Input,
  InputLabel,
  FormControl,
  Button,
} from "@material-ui/core";

import { constants } from '../../../constants';
function FirstTimeUserMsg({user}) {
  const [accessCode, setAccessCode] = useState(null);
  const [errMsg, setErrMsg] = useState(null);
  // let handleChange = prop => event => {
  //   setAccessCode(event.target.value);
  // };
  return <div className='blk-cntr'>
    <div style={{ width: 420 }}>
      <div style={{fontSize: "1.5rem", fontWeight: 500}}>Welcome!</div>
      <div style={{fontSize: "1.5rem", fontWeight: 500}}>Your registration was successful.</div>
      <p style={{margin: "28px 0px", lineHeight:1.4}}>Please input the ACCESS CODE provided to you so we create your session list</p>
      <form>
        <FormControl
          fullWidth
          className="input-cntr"
        >
          <InputLabel htmlFor="access-code">Access Code</InputLabel>
          <Input
            id="access-code"
            label="Access Code"
            type="text"
            autoComplete="off"
            value={accessCode ? accessCode : ''}
            onChange={ev => { setAccessCode(ev.target.value) }}
          />
        </FormControl>
        <FormControl
          fullWidth
          className="input-cntr"
        >
          <Button
            variant="raised"
            disabled={!accessCode}
            classes={{root:"action-btn", label:"btn-text"}}
            onClick={() => {
              fetch(`${constants.server}/access-code`, {
                method: 'POST',
                body: JSON.stringify({ accessCode, uid: user.uid })
              }).catch(err => {
                console.log(err)
              }).then(response => {
                console.log(response);
                response
                  .json()
                  .then(response => { if(!response.success){setErrMsg(response.errMsg)} });
              });
            }}
          >
            <span>Unlock Sessions</span>
          </Button>
        </FormControl>
          <div style={{fontSize: '0.75rem', color: '#F00', textAlign: 'center'}}>{errMsg}</div>
      </form>
    </div>
  </div>
}

export default FirstTimeUserMsg;